import styled, { css } from 'styled-components';
// import downIcon from '../../assets/icons/DownOutlined.svg';

export const Container = styled.div`
  ${css`
    display: flex;
    position:relative;
    flex-direction:column;
    align-items:center;
    height:auto;
    width:100%;
    font-family: Helvetica;


    animation: appears 1.2s;
    animation-fill-mode:both;

    @keyframes appears{
      from { opacity:0%; }
      to { opacity:100%; }
    };

    `}
`;

// display:flex;
// ${props=>
//   props.type === 'row'?
//   css`flex-direction:row;`
//   :
//   css`flex-direction:column;`
// }

export const Line = styled.div`

  width:100%;
  height:auto;

  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-auto-row: 1fr;
  row-gap:1.5rem;
  column-gap:1rem;

  margin: .5rem;
  overflow-wrap:normal;
  justify-content: space-evenly;
  align-content: center;
  color: #7a7a7a !important;
  

  @media screen and (max-width:800px){
    grid-template-columns: 1fr;
    grid-template-rows: auto;

    :nth-child(<=1){
      Pack{
        grid-column 1 / span 4;
      }
    }

  }

  ${props=> props.hightlight?css`
  @media screen and (min-width:600px){
    :focus-within{
      background-color:#e0e0e0;
      border-radius: calc(2rem + .3rem);
      padding: .3rem .3rem .3rem 1rem;
      transition:
         background-color .5s, padding .7s;
    }

    :not(:focus-within){
      background-color:none;
      padding:0rem;
      transition: background-color .5s, border-radius .6s, padding .7s;
      border-radius:none;
    }
  }
`
:
``
}

`;

export const Pack = styled.div`

  display:flex;
  flex-direction:row;
  grid-column:${props=> `${props.pos??'auto'}/ span ${props.fill??'1'}`};
  align-items:center;
  justify-content:center;

  @media screen and (max-width:750px){
    grid-column:auto;
    font-size:14px;
  }

  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;

`

export const ImageWrapper = styled.div`

  ${
    css`

    display:flex;

    height:100%;
    width:100%;
    justify-content: center;
    align-items: center;

    img {
      max-width: 70%;
      max-height: 70%;
      object-fit: contain;
    }
    `
  }
`

export const Button = styled.button`

  height:100%;
  // min-width:25%;
  width: ${props=>props.full? '100%':'auto'};
  justify-content:center;
  align-items:center;
  margin:2px;
  padding:.5rem;
  font-size:14px;
  border:solid;
  border-color:${(props)=>props.color??'#1B8917'};
  border-width: 1.5px;
  outline:none !important;
  background-color:${(props)=>props.color??'#1B8917'};
  color: white;
  border-radius:2rem;
  cursor:pointer;

  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;

  ${props=> props.selected?
    css`
    background-color: rgba(240,240,240,0.3);
    border: solid;
    font-weight:600;
    border-color:${(props)=>props.color??'#1B8917'};
    border-width: 1.5px;
    color: ${(props)=>props.color??'#1B8917'};
    // box-shadow: inset 1px 1px 2px .5px #00345760;

    transition all .3s;

    `
    :
    ''
  }

  ${props=> props.animation?css`
    :hover{
    animation: overButton .3s;
    animation-fill-mode: both;
    @keyframes overButton{
      from { width: 100%; }
      to {
        width:150%;
      }
    }
  }

  :not(:hover){

    animation: returnNormalButton .3s;
    animation-fill-mode: both;
    @keyframes returnNormalButton{
      from {
        width:150%;
      }
      to {
        width:100%;
      }
    }
  }`
  :
  ""
}

  @media(max-width:736px){
    border-radius:5rem;
  }


`;

export const Pill = styled.div`

  height:100%;
  min-width:50%;
  width:100%;

  display:flex;
  justify-content:center;
  align-items:center;
  text-align:center;

  // margin:2px;
  padding:.5rem;

  font-size:.85rem;
  font-weight: 500;
  color: ${(props)=>props.color??'#1B8917'} !important;

  border:solid;
  border-color:${(props)=>props.color??'#1B8917'};
  border-width: 1.5px;
  border-radius:2rem;

  outline:none !important;
  background-color: tranparent;
  cursor:default;

  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;

  @media(max-width:736px){
    border-radius:5rem;
  }

  @media(max-width:1023px){
    font-size:.75rem;
    margin:1.5px;
    padding:.3rem;
  }


`;

export const Form = styled.form`
  display: flex;
  flex-direction: row;
  padding:5px;
  height:auto;
  width:100%;
  justify-content: space-around;
  align-items: center;
`;

export const Input = styled.input`

  width:100%;
  height:100%;
  max-height: 3rem;
  border-radius: 5px;
  padding: .5rem .5rem .5rem 1rem;
  margin:2px;
  font-size:16px;
  outline:none;
  border:solid;
  border-width:1.4px;
  border-color:#F0F0F0;
  color: #7a7a7a;
  background-color:#F0F0F0;

  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;


  ${props =>{
    if(props.isValid){
      return css`
        border-color:#1B8917;
        border-width:2.2px;
        transition: border-width, border-color .5s;

      `
    }
  }}

  ${props =>{
    if(props.isInvalid){
      return css`
        border-color:#EE4245;
        border-width:2.2px;
        transition: border-width, border-color .5s;
      `
    }
  }}

`;

export const Select = styled.select`

-webkit-appearance: none;
 -moz-appearance: none;

  
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 12px 12px;

  option {
    width: calc(100% - 12px); // Adjustable
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  width:100%;
  height:100%;
  border-radius: 2rem;
  padding: .5rem .5rem .5rem 1rem;
  margin:2px;
  font-size:14px;
  outline:none;
  border:solid;
  border-width:1.4px;
  border-color:#d9d9d9;
  color: #525252;
  background-color:rgba(255,255,255,0.5);

  cursor:pointer;

`
export const Loader = styled.div`

  border: 16px solid #f3f3f370; /* Light grey */
  border-top: 16px solid transparent; /* Blue */
  border-width: 3.5px;
  border-radius: 50%;
  width: 1rem;
  height: 1rem;
  animation: spin 0.9s linear infinite;

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`